import { useState, FC, useCallback } from 'react'

import { Checkbox, Input } from '~ui'
import { useQueryParams } from '~hooks'
import { Accordion } from '~shared'
import { FiltersProps } from '../index'

import styles from './Filters.module.scss'

export interface Item {
  title: string
  name: string
  options: { value: string; label: string }[]
}

const Filters: FC<FiltersProps> = ({ items, searchable, isOpen }) => {
  const [term, setTerm] = useState('')
  const { query, replace } = useQueryParams()

  const onChange = useCallback(
    (name: string, value: string, isChecked: boolean) => {
      const namedOptions = query[name]
      const selectedCheckboxes = new Set(
        Array.isArray(namedOptions) ? namedOptions : [namedOptions]
      )

      if (isChecked) {
        selectedCheckboxes.add(value)
      } else {
        selectedCheckboxes.delete(value)
      }
      replace({ query: { ...query, [name]: [...selectedCheckboxes] } }, null, { shallow: true })
    },
    [query]
  )

  return (
    <div className={styles.filters}>
      {searchable && (
        <Input
          icon="loupe"
          placeholder="Search..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
        />
      )}

      {items.map(({ options, name, title }) => (
        <div key={title} className={styles.filter}>
          <Accordion
            isOpen={
              options.some(({ value }) =>
                Array.isArray(query[name]) ? query[name].includes(value) : query[name] === value
              ) || isOpen
            }
            openHeader={
              <>{options.length ? <span className={styles.title}>{title}</span> : null}</>
            }
            body={
              <div className={styles.options}>
                {options
                  .filter(({ label }) => label.toLowerCase().includes(term))
                  .map(({ value, label }) => (
                    <Checkbox
                      key={value}
                      label={label}
                      checked={
                        Array.isArray(query[name])
                          ? query[name].includes(value)
                          : query[name] === value
                      }
                      onChange={(e) =>
                        onChange(name, value, (e.target as HTMLInputElement).checked)
                      }
                    />
                  ))}
              </div>
            }
          />
        </div>
      ))}
    </div>
  )
}

export default Filters
